import { Languages } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useLanguage } from '@/contexts/LanguageContext';
import { cn } from '@/lib/utils';

const LanguageSwitcher = () => {
  const { language, setLanguage } = useLanguage();

  return (
    <div className="flex items-center gap-1 bg-muted/50 p-1 rounded-full">
      <Button
        variant="ghost"
        size="sm"
        onClick={() => setLanguage('de')}
        className={cn(
          'rounded-full px-3 h-8 text-xs font-semibold transition-all',
          language === 'de'
            ? 'bg-primary text-primary-foreground hover:bg-primary/90 shadow-md'
            : 'hover:bg-muted'
        )}
      >
        DE
      </Button>
      <Button
        variant="ghost"
        size="sm"
        onClick={() => setLanguage('en')}
        className={cn(
          'rounded-full px-3 h-8 text-xs font-semibold transition-all',
          language === 'en'
            ? 'bg-primary text-primary-foreground hover:bg-primary/90 shadow-md'
            : 'hover:bg-muted'
        )}
      >
        EN
      </Button>
    </div>
  );
};

export default LanguageSwitcher;
